export function getCompletedPercentage (applicant) {
  if (!applicant || !applicant.requirements || !applicant.requirements.length) return 0
  const completed = applicant.requirements.filter(r =>
    r.status && (r.status === 'complete' || r.status === 'submitted' || r.status === 'sentToApplicant')
  ).length
  return Math.round((completed / applicant.requirements.length) * 100)
}

export function getAssignedToText (people, managers) {
  if (!people) return '-'
  return people.map(item => {
    const found = managers.find(m => m.value === item)
    return found ? found.text : item
  }).filter(Boolean).join(', ')
}
